import React from 'react';

import ReportTestsModule from '../modules/ReportTestsModule.js';
import './Box.css';

const ReportTestsBox = ({ user, reportId, isSmallScreen }) => {
    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            <h4></h4>
            <ReportTestsModule 
                user={user} 
                reportId={reportId} 
                isSmallScreen={isSmallScreen}
            />
        </div>
    );
};

export default ReportTestsBox;
